import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/view/layout'
import login from '@/view/login/login'
import main from '@/view/main/main'
import detailReport from '@/view/main/detailReport'

Vue.use(Router)
const routers = new Router({
    mode: 'history',
    routes: [{
            path: '/:Tenant_Id/login', //登陆
            // path: '/login', //登陆
            name: 'login',
            component: login
        },
        {
            path: '/',
            component: layout, //整体页面的布局
            children: [{
                    path: 'main',
                    name: 'main',
                    component: main,
                    meta: {
                        title: '完工入库',
                        // roles: ['user'], //当前菜单哪些角色可以看到
                    }
                },
                {
                    path: 'detailReport',
                    name: 'detailReport',
                    component: detailReport,
                    meta: {
                        title: '单据详情',
                        // roles: ['user'], //当前菜单哪些角色可以看到
                    }
                }
            ]
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
});

export default routers;


// WEBPACK FOOTER //
// ./src/router/routers.js